<!--TODO: No Title?-->

<mat-dialog-content>
    @if (isLoaded) {
    @if (hasTcm) {
    <tcm-viewer [docType]="docType" [entityId]="entityId" [entityType]="entityType" [tcmEntity]="tcmEntity">
    </tcm-viewer>
    } @else {
    <attachment-viewer fxLayout="column" [docType]="docType" [entityId]="entityId" [entityType]="entityType"
        [isAdd]="isAdd" [localAttachments]="attachments" [canEdit]="!readOnly">
    </attachment-viewer>
    }
    } @else {
    <busy-indicator></busy-indicator>
    }
</mat-dialog-content>

@if (hasTcm) {
<mat-dialog-actions fxLayoutAlign="end">
    <button mat-button color="primary" (click)="close()" telemetry="Submission-AttachmentClose">
        Close
    </button>
</mat-dialog-actions>
}